<ion-header gaCategory="add_card_to_wallet">
  <ion-item lines="none" class="header-item">
    <ion-button slot="end" class="header-buttons" (click)="dismissModal()">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </ion-item>
  <ion-item lines="none" class="title-item">
    <ion-label>
      {{ "commons.link2wallet.title" | translate }}
    </ion-label>
  </ion-item>
</ion-header>
<ion-content gaCategory="link2wallet" *ngIf="account">

  <div class="modal-info">
    <ion-row>
      <ion-col>
        <div class="account-card-image"></div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!cannotProvision">
      <ion-col size="12">
        <div class="modal-ion-item">
          <ion-label class="modal-label">
            {{
            "commons.link2wallet.message" | translate: { programName: account.programName, walletType: walletType }
            }}
          </ion-label>
        </div>
      </ion-col>
    </ion-row>

    <!-- Cannot provision: show an error and ask the customer to contact support -->
    <ion-row *ngIf="cannotProvision">
      <ion-col size="12">
        <div class="modal-ion-item">
          <ion-label class="modal-label error-label">
            {{ "commons.link2wallet.cannotProvision" | translate }}
          </ion-label>
        </div>
      </ion-col>
    </ion-row>

    <!-- Preparing the card: loading indicator while the readiness status is Pending -->
    <ion-row *ngIf="isCheckingReadiness || isPreparingCard">
      <ion-col class="preparing-col">
        <ion-spinner name="crescent"></ion-spinner>
        <ion-label class="preparing-label" *ngIf="isPreparingCard">
          {{ "commons.link2wallet.preparingCard" | translate }}
        </ion-label>
      </ion-col>
    </ion-row>

    <!-- Ready for provisioning: enabled LINK2WALLET button -->
    <ion-row *ngIf="tokenlink">
      <ion-col>
        <a [href]="tokenlink" target="_blank" gaEvent="link_to_wallet" class="link-to-wallet-anchor">
          <ion-button class="action-button" color="primary" expand="block">{{ 'commons.link2wallet.link2wallet' |
            translate }}</ion-button>
        </a>
      </ion-col>
    </ion-row>

    <!-- Preparing: LINK2WALLET button shown but disabled until the card is ready -->
    <ion-row *ngIf="isPreparingCard && !tokenlink">
      <ion-col>
        <ion-button class="action-button" color="primary" expand="block" [disabled]="true">
          {{ 'commons.link2wallet.link2wallet' | translate }}
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-button class="action-button" expand="block" color="light" (click)="dismissModal()">
          {{ "commons.link2wallet.cancel" | translate }}
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
